// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company{
    color: #f1f1f1;
}

.mainNavbar {
    z-index: 9999 !important;
    background-color: #0f0f0f !important;
}

.navbar-nav .nav-link {
    color: white !important;
    padding: 8px 20px !important;
    margin-right: 15px;
    border-radius: 5px !important;
    text-align: center;
    background: linear-gradient(to right, #0f0f0f, #0f0f0f) !important;
}

.navbarNav{
    background: #0f0f0f !important;
    color: #f1f1f1;
}

.navbar-toggler{
    background: #0f0f0f !important;
    color: #f1f1f1;
}

.navDrop{
    background: #0f0f0f !important;
    color: #f1f1f1;
}

@media (max-width: 991px) {
    .navbar-nav .nav-link {
        margin-left: 45px;
    }
    .vk12{
        margin-left: 45px;
    }
}

.navbar-nav .nav-link:hover {
    background: #f1f1f1 !important;
    color: #0f0f0f !important;
}

.navDrop:hover{
    background: #f1f1f1 !important;
    color: #0f0f0f !important;
}

.dropdown-menu {
    background: #0f0f0f !important;
    margin-right: 15px;
    border: none;
    box-shadow: 0px 4px 6px #0e2238;
    text-align: center;
}

.dropdown-menu .dropdown-item {
    color: white !important;
    padding: 8px 20px !important;
    margin-right: 15px;
    border-radius: 5px !important;
    transition: background-color 0.3s ease;
    text-align: center;
    display: block;
}

.dropdown-menu .dropdown-item:hover {
    background: #f1f1f1 !important;
    color: #0f0f0f !important;
}

.dropdown-menu .dropdown-divider {
    background-color: #0f0f0f;
}


.navbar-toggler {
    background: #0f0f0f !important;
    color: #f1f1f1 !important;
    border: none !important;
}

.navDrop {
    background: #0f0f0f !important;
    color: #f1f1f1 !important;
    border: none !important;
}

.navbar-toggler:hover {
    color: #0f0f0f !important;
}

.navDrop:hover {
    background: #f1f1f1 !important;
    color: #0f0f0f !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/navbar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,kEAAkE;AACtE;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;IAC7B,sCAAsC;IACtC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B","sourcesContent":[".company{\n    color: #f1f1f1;\n}\n\n.mainNavbar {\n    z-index: 9999 !important;\n    background-color: #0f0f0f !important;\n}\n\n.navbar-nav .nav-link {\n    color: white !important;\n    padding: 8px 20px !important;\n    margin-right: 15px;\n    border-radius: 5px !important;\n    text-align: center;\n    background: linear-gradient(to right, #0f0f0f, #0f0f0f) !important;\n}\n\n.navbarNav{\n    background: #0f0f0f !important;\n    color: #f1f1f1;\n}\n\n.navbar-toggler{\n    background: #0f0f0f !important;\n    color: #f1f1f1;\n}\n\n.navDrop{\n    background: #0f0f0f !important;\n    color: #f1f1f1;\n}\n\n@media (max-width: 991px) {\n    .navbar-nav .nav-link {\n        margin-left: 45px;\n    }\n    .vk12{\n        margin-left: 45px;\n    }\n}\n\n.navbar-nav .nav-link:hover {\n    background: #f1f1f1 !important;\n    color: #0f0f0f !important;\n}\n\n.navDrop:hover{\n    background: #f1f1f1 !important;\n    color: #0f0f0f !important;\n}\n\n.dropdown-menu {\n    background: #0f0f0f !important;\n    margin-right: 15px;\n    border: none;\n    box-shadow: 0px 4px 6px #0e2238;\n    text-align: center;\n}\n\n.dropdown-menu .dropdown-item {\n    color: white !important;\n    padding: 8px 20px !important;\n    margin-right: 15px;\n    border-radius: 5px !important;\n    transition: background-color 0.3s ease;\n    text-align: center;\n    display: block;\n}\n\n.dropdown-menu .dropdown-item:hover {\n    background: #f1f1f1 !important;\n    color: #0f0f0f !important;\n}\n\n.dropdown-menu .dropdown-divider {\n    background-color: #0f0f0f;\n}\n\n\n.navbar-toggler {\n    background: #0f0f0f !important;\n    color: #f1f1f1 !important;\n    border: none !important;\n}\n\n.navDrop {\n    background: #0f0f0f !important;\n    color: #f1f1f1 !important;\n    border: none !important;\n}\n\n.navbar-toggler:hover {\n    color: #0f0f0f !important;\n}\n\n.navDrop:hover {\n    background: #f1f1f1 !important;\n    color: #0f0f0f !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
